import { useState } from "react";
import navbrand from "../../images/kegow-color.png";

function Navbar({ dashboard }) {
  const [showNavMobile, setShowNavMobile] = useState(false);

  return (
    <nav
      className={`${
        dashboard
          ? "navbar navbar-expand-lg navbar-light bg-white"
          : "navbar navbar-expand-lg navbar-light bg-white fixed-top  border-bottom"
      }`}
    >
      <div className={dashboard ? "container-fluid" : "container"}>
        <a className="navbar-brand" href="/">
          <img src={navbrand} className="navbar-brand-img" alt="Kegow logo" />
        </a>

        {dashboard ? (
          ""
        ) : (
          <>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded={showNavMobile}
              aria-label="Toggle navigation"
              onClick={() =>
                setShowNavMobile((showNavMobile) => !showNavMobile)
              }
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className={`collapse navbar-collapse ${
                showNavMobile ? "show" : ""
              }`}
              id="navbarCollapse"
            >
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded={showNavMobile}
                aria-label="Toggle navigation"
                onClick={() =>
                  setShowNavMobile((showNavMobile) => !showNavMobile)
                }
              >
                <i className="fe fe-x"></i>
              </button>

              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/">
                    Features
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
              </ul>

              <a
                className="navbar-btn btn btn-sm btn-primary lift ms-auto"
                href="/signup"
              >
                Signup
              </a>
            </div>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
